export const aciAssistance = {
    iconName: 'assistance',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M17.77 7.692H5.461A2.462 2.462 0 003 10.154v7.384A2.461 2.461 0 005.462 20h12.307a2.461 2.461 0 002.462-2.462v-7.384a2.461 2.461 0 00-2.462-2.462z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M7.926 7.692V5.231A1.23 1.23 0 019.156 4h4.923a1.23 1.23 0 011.231 1.23v2.462M11.614 11.369v4.923M9.154 13.83h4.923',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
